import { render } from "./CalendarJournal.vue?vue&type=template&id=486bd6e8&scoped=true"
import script from "./CalendarJournal.vue?vue&type=script&lang=js"
export * from "./CalendarJournal.vue?vue&type=script&lang=js"

import "./CalendarJournal.vue?vue&type=style&index=0&id=486bd6e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486bd6e8"]])

export default __exports__